import { render, staticRenderFns } from "./PayView.vue?vue&type=template&id=b80cc29c&scoped=true"
import script from "./PayView.vue?vue&type=script&lang=js"
export * from "./PayView.vue?vue&type=script&lang=js"
import style0 from "./PayView.vue?vue&type=style&index=0&id=b80cc29c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80cc29c",
  null
  
)

export default component.exports